// Removes first slash and ensures trailing slash
export const routeUrlToSlug = (url: string): string =>
  url.slice(1) + (url.endsWith('/') ? '' : '/');

export const safelyDecodeURIComponent = (uri: string): string => {
  try {
    return decodeURIComponent(uri);
  } catch {
    console.log(`Error decoding URIComponent: ${uri}`);
    return '';
  }
};

export const removeInvalidQueryStringCharacters = (input: string): string => {
  if (typeof input !== 'string') return '';
  const invalidQueryStringCharactersRegex = /(%3[ce])|<|>/gi;
  return input.replace(invalidQueryStringCharactersRegex, '');
};

export const getSlugFromPathname = (pathname: string, search: string): string => {
  return `${routeUrlToSlug(pathname)}${removeInvalidQueryStringCharacters(safelyDecodeURIComponent(search))}`;
};
